/* eslint-disable */
/// This file is auto generated - do not edit manually
export const OpenGWPModal = 'Website.Product.GwpOffer.OpenGWPModal';
export const OpenGWPModalPlural = 'Website.Product.GwpOffer.OpenGWPModalPlural';
export const GwpValue = 'Website.Product.GwpOffer.GwpValue';
export const GwpFromValue = 'Website.Product.GwpOffer.GwpFromValue';
export const GWPHeading = 'Website.Product.GwpOffer.GWPHeading';
